/*
 * Copyright (c) 2025, Ramble Ventures
 */

export const SettingsTable = function (props) {
    return (
        <table className="form-table">
            <tbody>
                {props.bodyChildren}
            </tbody>
        </table>
    )
}
